import { useTranslation } from 'react-i18next';
import classes from 'classnames';
import classNames from './LoginForm.module.scss';
import { useEffect, useState } from 'react';
import UseScreenSize from '@/hooks/UseScreenSize';
import logoLight from '@/assets/svg/logo_60x60.svg';

//TODO: Need to understand if it's needed
// import QuickLogin from '../QuickLogin/QuickLogin';
import TheButton from '../TheButton/TheButton';
import { UseLoginInterface } from '@/pages/login/UseLogin';
import { LoginStep } from '@/types/login';

interface LoginFormProps {
  hideWelcome: () => void;
  useLoginData: UseLoginInterface;
}

const LoginForm = ({ hideWelcome, useLoginData }: LoginFormProps) => {
  const { t } = useTranslation();
  const { loading, isFirstTime, LoginComponent, currentLoginStep, stepProps, setLoginStep } =
    useLoginData;

  const OnClassCode = async () => {
    setLoginStep(LoginStep.CLASS_CODE);
  };

  useEffect(() => {
    if (currentLoginStep?.type === 4) {
      hideWelcome();
    }
  }, [currentLoginStep, hideWelcome]);

  const { isDesktop, isMobile } = UseScreenSize();

  const [showForm, setShowForm] = useState(true);

  useEffect(() => {
    if (isDesktop && !isFirstTime) {
      setShowForm(false);
    }
  }, [isFirstTime, isDesktop]);

  const bottom = !showForm && (
    <TheButton
      className={classNames.loginFromDifferent}
      plain
      text={t('loginFromDifferent')}
      emitOnClick={() => setShowForm(true)}
    />
  );

  let title = currentLoginStep?.title;
  let subTitle = currentLoginStep?.subTitle;
  if (isMobile && currentLoginStep?.type === LoginStep.COGNITO_PASSWORD_CHANGE) {
    title = 'signIn';
    subTitle = 'pleaseChooseYourOwnPassword';
  }

  return (
    <div
      className={classes(classNames.loginForm, {
        [classNames.loginFormMobile]: isMobile,
      })}
    >
      {(currentLoginStep?.type === LoginStep.CLASS_CODE ||
        currentLoginStep?.type === LoginStep.CLASS_CODE_REGISTRATION) && (
        <img className='app-banner-logo' src={logoLight} alt={'logo'} />
      )}
      {(title || subTitle) && (
        <div className={classNames.top}>
          {title && <h2>{t(title)}</h2>}
          {subTitle && (
            <span>
              <span dangerouslySetInnerHTML={{ __html: t(subTitle).toString() }} />
              {currentLoginStep?.type === LoginStep.LOGIN && (
                <button className={classNames.classCodeBtn} onClick={OnClassCode}>
                  {t('clickHere')}
                </button>
              )}
            </span>
          )}
        </div>
      )}
      <div className={classNames.contentWrapper}>
        {LoginComponent && <LoginComponent styles={classNames} {...stepProps()} />}
      </div>
      {!loading && bottom}
    </div>
  );
};

export default LoginForm;
